import { computed } from 'vue'

import { calcMulAmount } from './calc'

const KEYS = {
  /** 砖混（现浇）结构 */
  zhuanHunXianJiaoJieGou: 'zhuanHunXianJiaoJieGou',
  /** 砖混（预制）结构 */
  zhuanHunYuZhiJieGou: 'zhuanHunYuZhiJieGou',
  /** 砖木结构（土墙小青瓦） */
  zhuanMuJieGouXiaoQingWa: 'zhuanMuJieGouXiaoQingWa',
  /** 土木、木结构（土墙小青瓦、砖墙草盖） */
  tuMuMuJieGou: 'tuMuMuJieGou',
  /** 其他结构（土墙草盖、板房） */
  qiTaJieGou: 'qiTaJieGou'
} as const

const RATE_KEY = 'chaiQianBuYuAnZhi' as const

export const useNoResettlePrice = (
  count: Partial<ApiJtZch.CompData>,
  standard: Partial<ApiJtProj.CompStandardData>,
  members: ApiFamilyMembers.Item[]
) => {
  /**
   * 标准：来自“标准录入”的配置值（界面展示为 %）。
   */
  const standardRate = computed(() => standard?.[RATE_KEY] ?? 0)
  /**
   * 单项金额计算：数量 * 标准，注意标准需要除以 100 转成小数。
   */
  const getItemPrice = (key: string) => calcMulAmount(count?.[key] ?? 0, standard?.[key] ?? 0)
  /** 砖混（现浇）结构-金额 */
  const zhuanHunXianJiaoJieGouPrice = computed(() => getItemPrice(KEYS.zhuanHunXianJiaoJieGou))
  /** 砖混（预制）结构-金额 */
  const zhuanHunYuZhiJieGouPrice = computed(() => getItemPrice(KEYS.zhuanHunYuZhiJieGou))
  /** 砖木结构（土墙小青瓦）-金额 */
  const zhuanMuJieGouXiaoQingWaPrice = computed(() => getItemPrice(KEYS.zhuanMuJieGouXiaoQingWa))
  /** 土木、木结构（土墙小青瓦、砖墙草盖）-金额 */
  const tuMuMuJieGouPrice = computed(() => getItemPrice(KEYS.tuMuMuJieGou))
  /** 其他结构（土墙草盖、板房）-金额 */
  const qiTaJieGouPrice = computed(() => getItemPrice(KEYS.qiTaJieGou))
  /**
   * 房屋主体补偿金额=砖混（现浇）结构+砖混（预制）结构+砖木结构（土墙小青瓦）+土木、木结构（土墙小青瓦、砖墙草盖）+其他结构（土墙草盖、板房）
   */
  const mainAmount = computed(() =>
    zhuanHunXianJiaoJieGouPrice.value
      .add(zhuanHunYuZhiJieGouPrice.value)
      .add(zhuanMuJieGouXiaoQingWaPrice.value)
      .add(tuMuMuJieGouPrice.value)
      .add(qiTaJieGouPrice.value)
  )
  /**
   * 是否补偿
   * 所有成员必须是非农户口且是不予安置的房屋才补偿，否则无
   */
  const hasComp = computed(() => members.length > 0 && members.every(member => !!member?.isAnZhi && !member?.isFarmer))
  /** 补偿金额 */
  const totalAmount = computed(() => (hasComp.value ? mainAmount.value.mul(standardRate.value).div(100).toNumber() : 0))
  return {
    standardRate,
    zhuanHunXianJiaoJieGouPrice,
    zhuanHunYuZhiJieGouPrice,
    zhuanMuJieGouXiaoQingWaPrice,
    tuMuMuJieGouPrice,
    qiTaJieGouPrice,
    mainAmount,
    hasComp,
    totalAmount
  }
}
